import { Branch } from './branch.model';
import { ProjectStatusHelper, RolesHelper } from './Enums';
import { Project } from './project.model';
import { Role } from './role.model';

export class User {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  igg: string;
  role_id: number;
  last_connection?: string;

  projects_as_affected_count: number;

  responsible_ids?: number[];
  can_export: boolean;
  responsibles?: User[];

  branches_ids!: number[];
  branches: Branch[] = [];

  role: Role;


  constructor(data: any = {}) {
    Object.assign(this, data);
    this.branches = [];
    for (let index = 0; index < data?.branches?.length; index++) {
      const element = data.branches[index];
      this.branches.push(new Branch(element));
    }
    
    // Handle responsibles (many-to-many)
    if (data?.responsibles) {
      this.responsibles = data.responsibles.map((resp: any) => new User(resp));
      this.responsible_ids = this.responsibles?.map(resp => resp.id);
    }
  }

  public getDisplayName(): string {
    return this.first_name ? this.first_name + ' ' + this.last_name : '-';
  }

  isSuperAdmin() {
    return this.role?.code === RolesHelper.SUPER_ADMIN;
  }

  is3PResponsible() {
    return this.role?.code === RolesHelper.RESP_3P;
  }

  is3pMember() {
    return this.role?.code === RolesHelper.MEMBRE_3P;
  }

  isPM() {
    return this.role?.code === RolesHelper.PM;
  }

  isInca() {
    return this.role?.code === RolesHelper.INCA;
  }

  isITAdmin() {
    return this.role?.code === RolesHelper.IT_ADMIN;
  }

  getBranchesIds(): number[] {
    return this.branches.map(branch => branch.id);
  }

  getBranchesNames(): string {
    return this.branches.map(branch => branch.name).join(', ');
  }

  canAffectProject() {
    return this.isSuperAdmin() || this.is3PResponsible();
  }

  hasBranch(branch_id: number): boolean {
    return this.branches.some(b => b.id == branch_id);
  }

  canEditProject(project: Project): boolean {
    if (this.isSuperAdmin()) {
      return true;
    }

    if (project.status.code === ProjectStatusHelper.INITIATED) {
      return (this.is3PResponsible() || this.isInca()) && this.hasBranch(project.branch_id);
    }

    if (this.is3pMember()) {
      return project.affectation_id === this.id;
    }

   /* if (this.is3PResponsible()) {
      return (project.affectation_id === this.id || 
              (project.affectation.responsible_ids && project.affectation.responsible_ids.includes(this.id))) || false;
    }*/
    if (this.is3PResponsible()) {
        // Un RESP_3P peut éditer si : Il est affecté au projet  OU il a la même branche que le projet
        return project.affectation_id === this.id || this.hasBranch(project.branch_id);
      }
    return false;
  }

  canSignProjectAsBusiness(project: Project): boolean {
    console.log(project);
    return project.main_business_pm.id === this.id || this.isSuperAdmin();
  }
}
